import { useState } from 'react'
import { Link } from 'react-router-dom'

// サンプル予約データ
const sampleReservations = [
  { id: 'res-001', date: '2025-11-28', time: '14:00', patient: 'KuKn', status: '完了' },
  { id: 'res-002', date: '2025-11-27', time: '16:30', patient: 'ItuHrs', status: '処理中' },
  { id: 'res-003', date: '2025-11-28', time: '12:00', patient: 'KuKn', status: '完了' },
  { id: 'res-004', date: '2025-12-01', time: '14:30', patient: 'SymTsk', status: '受付済' },
  { id: 'res-005', date: '2025-12-03', time: '14:00', patient: 'FmtHrv', status: '受付済' },
  { id: 'res-006', date: '2025-12-04', time: '11:00', patient: 'YsmrYuk', status: '保留中' },
  { id: 'res-007', date: '2025-12-05', time: '16:30', patient: 'OkNyu', status: '受付済' },
]

const getDaysInMonth = (year: number, month: number) => {
  return new Date(year, month + 1, 0).getDate()
}

const getFirstDayOfMonth = (year: number, month: number) => {
  return new Date(year, month, 1).getDay()
}

export default function ReservationCalendar() {
  const [currentDate, setCurrentDate] = useState(new Date(2025, 10)) // November 2025
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth()

  const daysInMonth = getDaysInMonth(year, month)
  const firstDay = getFirstDayOfMonth(year, month)

  const monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  const dayNames = ['日', '月', '火', '水', '木', '金', '土']

  const prevMonth = () => {
    setCurrentDate(new Date(year, month - 1))
  }

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1))
  }

  const getReservationsForDate = (day: number) => {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    return sampleReservations.filter((r) => r.date === dateStr)
  }

  // カレンダーグリッド生成
  const calendarDays = []
  for (let i = 0; i < firstDay; i++) {
    calendarDays.push(null)
  }
  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays.push(day)
  }

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">移植予約カレンダー</h1>
          <div className="aip-main__header-buttons">
            <Link to="/reservations/create" className="aip-button aip-button--solid-fill">
              <span className="material-symbols-outlined">add</span>
              予約作成
            </Link>
          </div>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="calendar-container">
          {/* カレンダーヘッダー */}
          <div className="calendar-header">
            <button onClick={prevMonth} className="aip-button aip-button--icon">
              <span className="material-symbols-outlined">chevron_left</span>
            </button>
            <h2 className="calendar-title">{year}年 {monthNames[month]}</h2>
            <button onClick={nextMonth} className="aip-button aip-button--icon">
              <span className="material-symbols-outlined">chevron_right</span>
            </button>
          </div>

          {/* カレンダーグリッド */}
          <div className="calendar-grid">
            {/* 曜日ヘッダー */}
            {dayNames.map((day, index) => (
              <div
                key={day}
                className={`calendar-day-header ${index === 0 ? 'calendar-day-header--sunday' : ''} ${index === 6 ? 'calendar-day-header--saturday' : ''}`}
              >
                {day}
              </div>
            ))}

            {/* 日付セル */}
            {calendarDays.map((day, index) => {
              const reservations = day ? getReservationsForDate(day) : []
              const dayOfWeek = index % 7

              return (
                <div
                  key={index}
                  className={`calendar-cell ${!day ? 'calendar-cell--empty' : ''} ${dayOfWeek === 0 ? 'calendar-cell--sunday' : ''} ${dayOfWeek === 6 ? 'calendar-cell--saturday' : ''}`}
                >
                  {day && (
                    <>
                      <div className="calendar-cell__date">{day}</div>
                      <div className="calendar-cell__events">
                        {reservations.slice(0, 3).map((res) => (
                          <Link
                            key={res.id}
                            to={`/reservations/${res.id}`}
                            className={`calendar-event calendar-event--${getStatusClass(res.status)}`}
                          >
                            {res.time} {res.patient}
                          </Link>
                        ))}
                        {reservations.length > 3 && (
                          <span className="calendar-more">
                            その他 {reservations.length - 3}件
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <style>{`
        .calendar-container {
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
          overflow: hidden;
        }

        .calendar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: var(--spacing-md) var(--spacing-lg);
          border-bottom: 1px solid var(--border-color);
        }

        .calendar-title {
          font-size: 1.25rem;
          font-weight: 600;
        }

        .calendar-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
        }

        .calendar-day-header {
          padding: var(--spacing-sm);
          text-align: center;
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--text-secondary);
          background-color: var(--color-solid-gray25);
          border-bottom: 1px solid var(--border-color);
        }

        .calendar-day-header--sunday {
          color: var(--color-alert);
        }

        .calendar-day-header--saturday {
          color: var(--color-blue600);
        }

        .calendar-cell {
          min-height: 100px;
          padding: var(--spacing-xs);
          border-right: 1px solid var(--border-color);
          border-bottom: 1px solid var(--border-color);
        }

        .calendar-cell:nth-child(7n) {
          border-right: none;
        }

        .calendar-cell--empty {
          background-color: var(--color-solid-gray25);
        }

        .calendar-cell--sunday .calendar-cell__date {
          color: var(--color-alert);
        }

        .calendar-cell--saturday .calendar-cell__date {
          color: var(--color-blue600);
        }

        .calendar-cell__date {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: var(--spacing-xs);
        }

        .calendar-cell__events {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .calendar-event {
          display: block;
          padding: 2px 4px;
          font-size: 0.625rem;
          border-radius: 2px;
          text-decoration: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .calendar-event--success {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .calendar-event--info {
          background-color: var(--color-blue100);
          color: var(--color-blue700);
        }

        .calendar-event--warning {
          background-color: var(--color-focus-light);
          color: #8b6914;
        }

        .calendar-event--neutral {
          background-color: var(--color-solid-gray100);
          color: var(--color-solid-gray700);
        }

        .calendar-more {
          font-size: 0.625rem;
          color: var(--text-secondary);
        }

        @media (max-width: 768px) {
          .calendar-cell {
            min-height: 60px;
          }

          .calendar-event {
            font-size: 0.5rem;
          }
        }
      `}</style>
    </>
  )
}

function getStatusClass(status: string): string {
  switch (status) {
    case '完了': return 'success'
    case '処理中': return 'info'
    case '受付済': return 'info'
    case '保留中': return 'warning'
    default: return 'neutral'
  }
}




